import pkg from 'package.json'

export const useVersion = () => console.log(pkg?.version ?? 'unset')
